import moment from 'moment';

import { getLang } from '../../utils/languaje';
import 'moment/locale/es';

moment.locale(getLang());
